import { render, staticRenderFns } from "./MyButtonYesNo.vue?vue&type=template&id=b5a9998e&scoped=true&"
import script from "./MyButtonYesNo.vue?vue&type=script&lang=js&"
export * from "./MyButtonYesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a9998e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a9998e')) {
      api.createRecord('b5a9998e', component.options)
    } else {
      api.reload('b5a9998e', component.options)
    }
    module.hot.accept("./MyButtonYesNo.vue?vue&type=template&id=b5a9998e&scoped=true&", function () {
      api.rerender('b5a9998e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyButtonYesNo.vue"
export default component.exports